module.exports = __webpack_public_path__ + "static/subset-UniNeueLight-Italic-5987349de9fff4380332b96a87447002.woff2";